import { render, staticRenderFns } from "./ServiceDirectory.vue?vue&type=template&id=853a6696&"
import script from "./ServiceDirectory.vue?vue&type=script&lang=js&"
export * from "./ServiceDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports